import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import Input from '../ui/Input';
import Button from '../ui/Button';
import AuthLayout from './AuthLayout';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const { FiLock } = FiIcons;

const ResetPassword = () => {
    const [loading, setLoading] = useState(false);
    const { updatePassword } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const password = formData.get('password');
        const confirmPassword = formData.get('confirmPassword');

        if (password !== confirmPassword) {
            toast.error('Passwords do not match');
            return;
        }

        setLoading(true);
        try {
            const { error } = await updatePassword(password);
            if (error) throw error;
            toast.success('Password updated successfully!');
            navigate('/login');
        } catch (error) {
            toast.error(error.message || 'Failed to update password');
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthLayout
            title="Set new password"
            subtitle="Choose a strong password you haven't used before."
        >
            <form onSubmit={handleSubmit} className="space-y-6">
                <Input
                    label="New Password"
                    placeholder="••••••••"
                    type="password"
                    name="password"
                    icon={FiLock}
                    required
                />
                <Input
                    label="Confirm Password"
                    placeholder="••••••••"
                    type="password"
                    name="confirmPassword"
                    icon={FiLock}
                    required
                />
                <Button type="submit" className="w-full" isLoading={loading}>
                    Update password
                </Button>
            </form>
        </AuthLayout>
    );
};

export default ResetPassword;